import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=731ffc50"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=731ffc50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports